// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectable-item[data-v-ce902866] {\n  border-radius: 0.5rem;\n}\n.selectable-item.selected[data-v-ce902866] {\n  background-color: #effefb;\n  color: #00a78d;\n  border-color: #00a78d !important;\n}", ""]);
// Exports
module.exports = exports;
